import React from 'react';
import styled from 'styled-components';

const WrapComponent = ({children}) => {
    return <Wrap>{children}</Wrap>;
};

const Wrap = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index:100;
`;

export default WrapComponent;



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/service/serviceAsseblyLayer/piece/wrapCompoent.js